<template>
  <!-- "re-checked maximum" status + stamp button; renders nothing on an older server (check === null) -->
  <div v-if="check && (status.variant !== 'hidden' || message)" class="max-seniority-check mt-1" dir="rtl">
    <p v-if="status.variant === 'not_rechecked'" class="is-size-7 has-text-grey max-seniority-check-status" data-variant="not_rechecked">{{ status.text }}</p>
    <p v-else-if="status.variant !== 'hidden'" class="is-size-7 has-text-grey max-seniority-check-status" :data-variant="status.variant">{{ status.label }}{{ status.tag ? ' ' : '' }}<span v-if="status.tag" class="tag is-light is-rounded max-seniority-check-ai">({{ status.tag }})</span>: {{ status.detail }}</p>
    <div v-if="button.visible" class="mt-1">
      <button
        type="button"
        class="button is-small is-info is-light max-seniority-check-button"
        :class="{ 'is-loading': busy }"
        :disabled="button.disabled"
        @click="$emit('confirm')"
      >{{ texts.button }}</button>
      <p v-if="button.hint" class="is-size-7 has-text-grey mt-1 max-seniority-check-hint">{{ button.hint }}</p>
    </div>
    <p v-if="message" class="is-size-7 has-text-danger-dark mt-1 max-seniority-check-message">{{ message }}</p>
  </div>
</template>

<script>
import { TEXTS, buildMaxSeniorityStatus, maxSeniorityConfirmState } from '@/custom/classes/max_seniority_check.js'

export default {
  name: 'PositionMaxSeniorityCheck',
  props: {
    // pickMaxSeniorityCheck(...) result; null = older server
    check: { type: Object, default: null },
    // the maximum the server last confirmed
    savedMax: { type: [Number, String], default: null },
    // what is currently typed in the Max Seniority input
    inputValue: { type: [Number, String], default: null },
    busy: { type: Boolean, default: false },
    message: { type: String, default: '' }
  },
  computed: {
    texts () {
      return TEXTS
    },
    status () {
      return buildMaxSeniorityStatus(this.check, this.savedMax)
    },
    button () {
      return maxSeniorityConfirmState({
        check: this.check,
        savedMax: this.savedMax,
        inputValue: this.inputValue,
        busy: this.busy
      })
    }
  }
}
</script>

<style scoped>
  .max-seniority-check-ai {
    font-size: 0.65rem;
    height: auto;
    padding: 0 0.4em;
    vertical-align: baseline;
  }
</style>
